import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import type {ShowModelPayload} from '../../types'

import {ModelLayout} from '../../components/models/ModelLayout'
import {SafeHTMLBox} from '@github-ui/safe-html'

export function Evaluation() {
  const {modelEvaluation} = useRoutePayload<ShowModelPayload>()

  return (
    <ModelLayout activeTab="evaluation">
      {modelEvaluation && <SafeHTMLBox html={modelEvaluation} className="p-3" />}
    </ModelLayout>
  )
}

try{ Evaluation.displayName ||= 'Evaluation' } catch {}